<template lang="pug">
  .container.grid-lg
    page-title(title="Transferências" icon="fas fa-exchange-alt" subtitle="Lista das transferências que você recebeu")
      div(slot="actions")
        router-link.btn.btn-action.btn-link.text-error.tooltip.tooltip-left(:to="{ name: 'help.transfers.info' }" data-tooltip="Ajuda")
          i.fas.fa-question
    list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
      table.table(v-if="list && list.rows.length > 0")
        thead
          tr
            th #
            th Data / Hora
            th.text-right Valor
        tbody
          tr(v-for="transfer in list.rows" :key="transfer.id")
            td {{ `#${transfer.id}` }}
            td {{ transfer.createdAt | date('DD/MM/YYYY HH:mm') }}
            td.text-bold.text-success.text-bold.text-right {{ transfer.amount | currency('R$ ') }}
</template>

<script>
import listMixin from '@/mixins/list'
import transfers from '@/services/api/transfers'

export default {
  mixins: [listMixin],
  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await transfers.list(params)
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
